<template>
    <rkm-table
        :fields="fields"
        :filter-ignored-fields="['dataHoraAgendamento', 'usuarioAgendamento']"
        :items="agendamentos"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                :id="uniqueId(`agendamento-retroativo-detalhe-${item.id}`)"
                small
            >
                <rkm-icon icon="info" />
            </rkm-button>

            <rkm-popover
                :target="uniqueId(`agendamento-retroativo-detalhe-${item.id}`)"
                placement="top"
                title="Detalhes do agendamento"
                triggers="hover"
            >
                <div>
                    <span>
                        <strong>Usuário:</strong> {{item.usuarioAgendamento}}
                    </span>
                </div>

                <div>
                    <span>
                        <strong>Data/Hora:</strong> {{item.dataHoraAgendamento}}
                    </span>
                </div>

                <div v-if="item.motivoCancelamento">
                    <span>
                        <strong>Motivo cancelamento:</strong> {{ item.motivoCancelamento }}
                    </span>
                </div>
            </rkm-popover>

            <rkm-button
                :disabled="!item.permiteExclusao"
                @click="print(item.id)"
                color="info"
                small
                title="Imprimir protocolo"
            >
                <rkm-icon icon="print" />
            </rkm-button>

            <rkm-button
                :disabled="!item.permiteExclusao"
                @click="destroy(item.id)"
                authorize="destroy-ambulatorio-agendamento-retroativo"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import {error, file, formats, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        fields(){
            return [
                {key: 'unidade', label: 'Unidade', sortable: true},
                {key: 'infraestrutura', label: 'Local de atendimento', sortable: true},
                {key: 'usuario', label: 'Profissional', sortable: true},
                {key: 'ocupacao', label: 'CBO', sortable: true},
                {key: 'especialidade', label: 'Especialidade', sortable: true},
                {key: 'tipo', label: 'Tipo de atendimento', sortable: true},
                {formatter: value => this.formatDate(value), filterByFormatted: true, key: 'data', label: 'Data', sortable: true},
                {key: 'horario', label: 'Hora', sortable: true},
                {key: 'status', label: 'Status', sortable: true},
                {key: 'actions', label: 'Ações', class: 'col-min text-center'},
            ]
        },
    },
    created() {
        this.repositories = {
            agendamentoRetroativo: this.getConectaSusRepository('ambulatorio.agendamentoRetroativo'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        print(id) {
            this.setLoading()

            this.repositories.impressao.agendamento(id)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        destroy(id) {
            const destroy = () => this.repositories.agendamentoRetroativo.destroy(id)
                .then(() => this.$emit('deleted'))

            this.showDeleteConfirmation('Deseja realmente excluir o agendamento?', destroy)
        },
    },
    mixins: [error, file, formats, repository, stringCase],
    props: {
        agendamentos: {type: Array, required: true},
    },
}
</script>